const NewsList2022 = [

    {
        dt: "",
        my: "December",
        link: "https://iittp.ac.in/news",
        title: "Congratulations to Ms. Chinthalapudi Naga Lakshmi",
        desc: "Ms. Chinthalapudi Naga Lakshmi, received “Best Oral presentation Award” from Indian Chemical Engineering Congress (CHEMCON-2022), International Conference on sustainability in chemical processes through digitalization, Artificial intelligence and green chemistry held on Dec 27th – 30th, 2022, at HBTU, Kanpur."
    },
    {
        dt: "3",
        my: "November",
        link: "https://iittp.ac.in/news",
        title: "Congratulations to Dr. Koteswara Rao Bommisetti",
        desc: "Dr.Koteswara Rao Bommisetti (Assistant Professor, Dept. of Physics) got a mentorship grant for the 'National Post-Doctoral Fellowship' scheme from SERB."
    },
    {
        dt: "2",
        my: "November",
        link: "https://iittp.ac.in/news",
        title: "Congratulations to Prof. Mamilla Ravi Sankar",
        desc: "Prof. Mamilla Ravi Sankar (Professor, Dept. of Mechanical Engineering) got a mentorship grant for the 'National Post-Doctoral Fellowship' scheme from SERB."
    },
    {
        dt: "2",
        my: "September",
        link: "https://iittp.ac.in/news",
        title: "Congratulations to Dr. B. Janaki Ramaiah",
        desc: "Dr. B. Janaki Ramaiah co-opted as a member to the panel of Revision of Indian Standard (IS) 4968- 'Method for subsurface sounding for soils' and Indian Standard (IS) 10589- 'Equipment for subsurface sounding of soils' under BIS Section 'Soil and Foundation Engineering CED 43:P14002E'."
    },
    {
        dt: "July",
        my: "2022",
        link: "https://iittp.ac.in/news",
        title: "Congratulations to Mr. Selvakumar",
        desc: "Mr. Selvakumar, CH Research scholar (Supervisor: Prof. KSMS Raghavarao & Dr. Trivikram Nallamilli) received the prestigious 'Prime Minister Fellowship', from Confederation of Indian Industry (CII), Government of India."
    },
    {
        dt: "18",
        my: "August",
        link: "https://iittp.ac.in/news",
        title: "Congratulations to Dr. Panchatcharam Mariappan",
        desc: "Dr. Panchatcharam Mariappan is honoured as DAAD Research Ambassador. The tenure ship of this honorary position is three years (2022 to 2025)."
    },
    {
        dt: "16",
        my: "August",
        link: "https://iittp.ac.in/news",
        title: "Congratulations to Mr. Syed Yunus Ali",
        desc: "Mr. Syed Yunus Ali, Senior Research Scholar of the Department of Chemistry (Supervisor: Dr. Debasish Mondal) has received S. S. Bhatnagar Young Scientist Award for the Oral Presentation in the Celebration of the 161st Birth Anniversary of Acharya Prafulla Chandra Ray organized by the Indian Chemical Society in association with the Bangladesh Chemical Society, Bangladesh and Department of Chemistry, Jadavpur University, Kolkata during July 30-31 & August 02-03, 2022."
    },
    {
        dt: "9",
        my: "August",
        link: "https://www.thehansindia.com/andhra-pradesh/iitt-tcs-ink-pact-for-academic-research-collaboration-756987",
        title: "MoU with the Tata Consultancy Services (TCS)",
        desc: "IIT Tirupati (IITT) has entered into a MoU with the Tata Consultancy Services (TCS) for academic and research collaboration."
    },
    {
        dt: "11",
        my: "April",
        link: "https://www.quantiki.org/position/joint-phd-programme-quantum-sciences-and-technologies-offered-cquere-and-iit-tirupati",
        title: "Quantum Sciences and Technologies",
        desc: "Joint PhD Programme on Quantum Sciences and Technologies offered by CQuERE and IIT Tirupati."
    },
    {
        dt: "January",
        my: "2022",
        link: "https://iittp.ac.in/newsletter",
        title: "Newsletter January 2022",
        desc: "Volume 5, Issue 2  July 2022"
    },
];
export default NewsList2022;